<template>
    <div>
        <data-table
                :url="api.ACTIONS.EMPLOYMENT_TYPE"
                title="EmploymentTypes"
                :titles="titles"
                :input-types-add="{
                     job_type: {items: ['FULL', 'PART'],clearable: true}
                }"
                :fields-extra-add="fieldsExtraAdd"
                :formatter="formatter"
                :actions-extra-main="actionsExtraMain"
                :fields-hidden-main="['updated_at','created_at']"
                :fields-hidden-add="['id','updated_at','created_at']"
                :fields-disabled-edit="['id','updated_at','created_at']"
        />
    </div>
</template>
<script>
    import DataTable from "@/components/wasilni/DataTable";

    export default {
        name: "EmploymentTypes",
        components: {DataTable},
        computed: {
            titles() {
                return {
                    id: '#',
                    name: 'Name',
                    apply_daily_meeting_constrains: "has daily meeting"
                }
            },
            fieldsExtraAdd() {
                return {
                    name: 'v-text-field',
                    weekly_shifts: 'v-text-field',
                    shift_long: 'v-text-field',
                    job_type: 'v-select',
                    no_justification_needed_in_minutes: 'v-text-field',
                    apply_daily_meeting_constrains: 'v-checkbox'
                };
            },
            formatter() {
                return {
                    apply_daily_meeting_constrains: (value) => value == 1 ? "YES" : "NO",
                }
            },
            actionsExtraMain() {
                return {
                    delay_policies: {
                        icon: 'alarm',
                        extras: {
                            color: 'gray'
                        },
                        action: (item) =>
                            this.$router.push({
                                name: "DelayPolices",
                                params: {"id": item.id}
                            })
                    },
                    general_holidays: {
                        icon: 'insert_emoticon',
                        extras: {
                            color: 'gray'
                        },
                        action: (item) =>
                            this.$router.push({
                                name: "GeneralHolidays",
                                params: {"id": item.id}
                            })
                    }
                }
            },

        }
    }
</script>

<style scoped>
</style>
